import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WaitForImageModule } from '../wait-for-image/wait-for-image.module';
import { CompanyLogoComponent } from './company-logo/company-logo.component';
import { IconsModule } from '../icons/icon.module';

@NgModule({
  declarations: [CompanyLogoComponent],
  imports: [CommonModule, IconsModule, WaitForImageModule],
  exports: [CompanyLogoComponent]
})
export class LogoModule {}
